import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/prismjs";
import "bootstrap";

import VueGapi from "vue-gapi";
import VueShopifyDraggable from "vue-shopify-draggable";
import Vue3Tour from "vue3-tour";
import "vue3-tour/dist/vue3-tour.css";

import Toaster from "@meforma/vue-toaster";

import GoogleSignInPlugin from "vue3-google-signin";
import vue3GoogleLogin from "vue3-google-login";

const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(VueGapi, {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
  clientId: process.env.VUE_APP_GOOGLE_CLIENTID,
  discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
  scope: "https://www.googleapis.com/auth/spreadsheets", //profile
});
app.use(GoogleSignInPlugin, {
  clientId: process.env.VUE_APP_GOOGLE_CLIENTID,
});
app.use(vue3GoogleLogin, {
  clientId: process.env.VUE_APP_GOOGLE_CLIENTID,
});
app.use(VueShopifyDraggable);
app.use(Vue3Tour);
app.use(Toaster);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
